import {
    ADD_PATIENT_REQUEST,
    GET_PATIENT_LIST_REQUEST,
    ADD_BOOKING_REQUEST,
    DELETE_PATIENT_REQUEST,
    EDIT_PATIENT_REQUEST,
    UPDATE_GUIDE_REQUEST,
    GET_CASE_DETAILS_REQUEST,
    ADD_PICKUP_REQUEST,
    GET_PARENT_CASES
} from './constants'
import {
    addPatientSuccess,
    addPatientFailure,
    getPatientSuccess,
    getPatientFailure,
    addBookingSuccess,
    addBookingFailure,
    deletePatientSuccess,
    deletePatientFailure,
    editPatientSuccess,
    editPatientFailure,
    updateGuideSuccess,
    updateGuideFailure,
    getCaseSuccess,
    getCaseFailure, addPickupSuccess, addPickupFailure, getParentCasesFailure, getParentCasesSuccess
} from "./actions";
import {call, put, takeLatest} from "redux-saga/effects";
import remote from "../../../../services/remote";
import SentryManager from "../../../../monitoring/Sentry";

function* addPatient (action) {
    try {
        const response = yield call(remote, {
            route: '/patient/add-patient',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(addPatientSuccess(response.data));
        } else {
            yield put(addPatientFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getPatient (action) {
    const queryParams = [];
    Object.keys(action.data).forEach(key => {
        if(typeof action.data[key] === 'object') {
            queryParams.push(`${key}=${JSON.stringify(action.data[key])}`);
        } else if(key !== 'patientId') {
            queryParams.push(`${key}=${action.data[key]}`);
        }
    });
    try {
        const url = `/patient/get-patients${(action.data.patientId) ? '/' + action.data.patientId : ''}?${queryParams.join('&')}`;
        const response = yield call(remote, {
            route: url,
            method: 'get'
        });
        if (response.success) {
            yield put(getPatientSuccess(response.data));
        } else {
            yield put(getPatientFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* addBooking (action) {
    try {
        const response = yield call(remote, {
            route: '/bookings/add-booking',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(addBookingSuccess(response.data));
        } else {
            yield put(addBookingFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* deletePatient (action) {
    try {
        const response = yield call(remote, {
            route: '/patient/delete-patient',
            method: 'delete',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(deletePatientSuccess(response.data));
        } else {
            yield put(deletePatientFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* editPatient (action) {
    try {
        const response = yield call(remote, {
            route: '/patient/edit-patient',
            method: 'put',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(editPatientSuccess(response.data));
        } else {
            yield put(editPatientFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* updateGuide (action) {
    try {
        const response = yield call(remote, {
            route: '/guide/update-guide',
            method: 'put'
        });
        if (response.success) {
            yield put(updateGuideSuccess(response.data));
        } else {
            yield put(updateGuideFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getCaseDetails (action) {
    const url = `/bookings/get-booking/${action.caseId}`;
    try {
        const response = yield call(remote, {
            route: url,
            method: 'get'
        });
        if (response.success) {
            yield put(getCaseSuccess(response.data));
        } else {
            yield put(getCaseFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* schedulePickup (action) {
    const url = `/bookings/add-pickup`;
    try {
        const response = yield call(remote, {
            route: url,
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(addPickupSuccess(response.data));
        } else {
            yield put(addPickupFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getParentCases () {
    try {
        const response = yield call(remote, {
            route: '/bookings/get-parent-bookings',
            method: 'get'
        });
        if (response.success) {
            yield put(getParentCasesSuccess(response.data));
        } else {
            yield put(getParentCasesFailure());
        }
    } catch (e) {
        console.error(e);
    }
}

export default function* watchPatient() {
    yield takeLatest(ADD_PATIENT_REQUEST , addPatient);
    yield takeLatest(GET_PATIENT_LIST_REQUEST , getPatient);
    yield takeLatest(ADD_BOOKING_REQUEST , addBooking);
    yield takeLatest(DELETE_PATIENT_REQUEST , deletePatient);
    yield takeLatest(EDIT_PATIENT_REQUEST , editPatient);
    yield takeLatest(UPDATE_GUIDE_REQUEST , updateGuide);
    yield takeLatest(GET_CASE_DETAILS_REQUEST , getCaseDetails);
    yield takeLatest(ADD_PICKUP_REQUEST , schedulePickup);
    yield takeLatest(GET_PARENT_CASES , getParentCases);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Home/saga.js